<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: "App",
  provide (){
    return {
      reload:this.reload
    }
  },
  data() { 
    return{
      isRouterAlive:true
    }
  },
  created() {
    if (sessionStorage.getItem("store")) {
      // replaceState 替换state根状态（参数为 对象）
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  methods: {
    reload(){
      this.isRouterAlive =false;
      this.$nextTick(()=>{
        this.isRouterAlive =true;
      });
    },
  }
};
</script>

<style lang="less">
@import "./assets/iconfont/iconfont.css";
@import "./assets/css/commonStyle.less";
@import "./assets/css/style.less"; //自定义组件样式
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
.bar::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}
.bar::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #86cbfd;
}
.bar::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #1f94f1;
}
// 表格样式
// .tables {
//   /deep/ .el-table th {
//     background: #f2f2f2;
//   }
//   /deep/ .el-table,
//   .el-table__expanded-cell {
//     box-shadow: 0 2px 15px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
//     border-radius: 5px;
//     background-color: transparent;
//     text-align: center;
//   }

//   /deep/ .el-table tr {
//     background-color: transparent !important;
//   }
//   /deep/ .el-table--enable-row-transition .el-table__body td,
//   .el-table .cell {
//     background-color: transparent;
//   }
// }

/* * 自定义表格样式 */
.myTable /deep/ .el-table, .el-table__expanded-cell {
  background-color: transparent;
}

// 表格标题
.myTable /deep/ .el-table th {
  background: #F2F2F2;
  color: #333B4D;
  text-align: center;
}

// 表格行背景
.myTable /deep/ .el-table tr {
  // background #f00
  background-color: transparent;
  text-align: center;
}

// 修改行内线的颜色
.myTable /deep/ .el-table--striped .el-table__body tr.el-table__row--striped td {
  // background #1f2
}

.myTable /deep/ .el-table th>.cell {
  // border-right 1px solid #848484;
}

.myTable /deep/ .el-table thead th:nth-last-child(2)>.cell {
  // border-right none;
}

// 修改行内线的颜色
.myTable /deep/ .el-table td, .building-top .el-table th.is-leaf {
  // border-bottom 1px solid #f00
}

// #修改表格最底部边框颜色和高度
.myTable /deep/ .el-table::before {
  // border-bottom 1px solid #f00
  height: 0px;
}

// 修改表头字体颜色
.myTable /deep/ .el-table thead {
  font-weight: 500;
}

//日期时间样式
.el-picker-panel {
  background: #092e5f !important;
}

.el-picker-panel__body {
  background: #092e5f !important;
  color: #74c8fe !important;
  .el-picker-panel__icon-btn {
    color: #0479b4!important;
  }
  .el-input__inner {
    background: #092e5f!important;
  }
  .el-time-panel {
    background: #092e5f!important;
    color: #74c8fe !important;
    .el-time-spinner__item {
      color: #74c8fe !important;
    }
    .el-time-spinner__item:hover {
      background: #0479b4!important;
    }
  }
}
.el-picker-panel__footer {
  background: #092e5f !important;
  .el-button.is-plain:active {
    background-image: linear-gradient(#0479b4, #02407e)!important;
  }
  .is-plain {
    background: #092e5f !important;
  }
}
.el-dropdown-menu {
  background: #092e5f;
  color: #74c8fe !important;
  border: none;
  .el-dropdown-menu__item {
    color: #74c8fe !important;
  }
  .el-dropdown-menu__item:hover {
    background: #092e5f !important;
  }
}

// 弹框样式
.myDialog{
  /deep/ .el-dialog {
    background-color: rgb(9, 46, 95) !important;
    box-shadow: 0 0 15px #00a8ff  inset !important;
    border: 4px solid rgba(0,156,255,0.85) !important;
    border-radius: 8px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue